/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useMemo, useState } from "react";
import { CSVLink } from "react-csv";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import moment from "moment-timezone";
import { Container } from "@material-ui/core";
import SingleSelectNew from "../../../../components/SelectField/SingleSelectNew";
import { getCompanyClients } from "../../../../services/apiservices/client";
import CircularProgress from "@mui/material/CircularProgress";
import * as Excel from 'exceljs';
import { downloadPDF, downloadExcel } from "../../DownloadReportUtils";
import { useMediaQuery } from "@mui/material";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import AuthContext from "../../../../hooks/authContext";
import ActionRender from "../../ActionRender";
import { Label } from "../../../../components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../../../components/ui/card";
import { Calendar, Download, FileSpreadsheet, FileText, Filter, Info, Mail } from "lucide-react";
import { Button } from "../../../../components/ui/button";
import { getUpcomingClientTimesheetListReport } from "../../../../services/apiservices/timesheets";
import { getEmployeesListBasedOnId } from "../../../../services/apiservices/employee";
import { Popover, PopoverContent, PopoverTrigger } from "../../../../components/ui/popover";
import ThemeTable from "../../../../components/Table/ThemeTable";
import { MobileUpcomingAppointmentReport } from "../ClientMobileViewReports";
import EmailReports from "../../EmailReports";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../../../components/ui/tooltip";
import { getSettings } from "../../../../services/apiservices/settings";

function UpcomingAppointments(props) {
  const csvHeaders = [
    "Client",
    "Date",
    "Time",
    "EndTime",
    "Shift",
    "Assinged",
    "Location",
    "Status",
  ];
  const [clientsList, setClientList] = useState([]);
  const [clientsListMaster, setClientsListMaster] = useState([]);
  const [clientsListCSV, setClientListCSV] = useState([csvHeaders]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [openEmailDialog, setOpenEmailDialog] = useState(false);
  const [clients, setClients] = useState();
  const [settingsData, setSettingsData] = useState();
  const [clientName, setClientName] = useState("All");
  const [clientNameList, setClientNameList] = useState([
    { label: "All", value: "All" },
  ]);
  const isMobile = useMediaQuery('(max-width:767px)');
  const isLandscape = useMediaQuery('(min-width: 771px) and (max-width: 940px)');
  const auth = useContext(AuthContext);
  const [loader, setLoader] = useState(false);
  const companyId = auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;

  const getColumns = () => {
    const columns = [
      {
        id: "clientName",
        numeric: false,
        disablePadding: false,
        label: "Client",
        isSortable: false,
      },
      {
        id: "appointmentDate",
        numeric: false,
        disablePadding: false,
        label: "Date",
        isSortable: false,
      },
      {
        id: "time",
        numeric: false,
        disablePadding: false,
        label: "Time",
        isSortable: false,
      },
      {
        id: "endtime",
        numeric: false,
        disablePadding: false,
        label: "EndTime",
        isSortable: false,
      },
      {
        id: "shift",
        numeric: false,
        disablePadding: false,
        label: "Shift",
        isSortable: false,
      },
      {
        id: "team",
        numeric: false,
        disablePadding: false,
        label: "Assinged",
        isSortable: false,
      },
      {
        id: "location",
        numeric: false,
        disablePadding: false,
        label: "Location",
        isSortable: false,
      },
      {
        id: "status",
        numeric: false,
        disablePadding: false,
        label: "Status",
        isSortable: false,
      },
      {
        id: "Action",
        numeric: false,
        disablePadding: false,
        label: "Action",
        isSortable: false,
      },
    ];
    if (isMobile || isLandscape) {
      return columns.filter(col => col.id !== "clientName" && col.id !== "appointmentDate" && col.id !== "Action");
    }
    return columns;
  };

  useEffect(() => {
    const getClientsData = async () => {
      const [clientRes, settingsRes] = await Promise.all([
        new Promise((resolve) => getCompanyClients(companyId, resolve)),
        new Promise((resolve) =>
          getSettings("client_settings", (res) => resolve(res?.data))
        ),
      ]);
      const details = Array.isArray(clientRes?.data) ? clientRes?.data : [];
      const client = details?.map((item) => {
        return {
          value: item?.id,
          label: `${item?.firstName} ${item?.lastName}`,
        };
      });
      const filteredData = settingsRes?.filter(
        (item) => item?.companyId === companyId && !item.deleted
      );
      setSettingsData(filteredData?.length ? filteredData : []);
      setClients(details);
      setClientNameList([{ label: "All", value: "All" }, ...client]);
    };
    getClientsData();
  }, []);

  const handleclientNameChange = (e) => {
    const str = e;
    setClientName(str);
    if (str === "All") {
      setClientList(clientsListMaster);
    } else {
      setClientList(() =>
        clientsListMaster?.filter((itme) => {
          let returnFlg = true;
          if (str !== "All" && returnFlg) {
            returnFlg = itme?.clientNameId === str;
          }
          return returnFlg;
        })
      );
    }
  };

  const getDatatoDownload = (rcellItem) => {
    let clientCSV = [];
    if (!Array.isArray(rcellItem)) {
      clientCSV = clientsList?.filter(
        (item) => item.clientNameId === rcellItem.clientNameId
      );
      clientCSV = clientCSV?.map((item) => {
        return [
          item?.clientName,
          item?.appointmentDate,
          item?.time,
          item?.endtime,
          item?.shift,
          item?.team,
          item?.location,
          item?.status,
        ];
      });
    } else {
      clientCSV = rcellItem?.map((item) => {
        return [
          item?.clientName,
          item?.appointmentDate,
          item?.time,
          item?.endtime,
          item?.shift,
          item?.team,
          item?.location,
          item?.status,
        ];
      });
    }
    return clientCSV;
  }

  const getDatatoFullDownload = (rcellItem) => {
    if (rcellItem) {
       clientsList?.filter(
        (item) => item.clientNameId === rcellItem.clientNameId
      );
      return [
        rcellItem?.clientName,
        rcellItem?.appointmentDate,
        rcellItem?.time,
        rcellItem?.endtime,
        rcellItem?.shift,
        rcellItem?.team,
        rcellItem?.location,
        rcellItem?.status,
      ];
    } else {
      return [
        rcellItem?.clientName,
        rcellItem?.appointmentDate,
        rcellItem?.time,
        rcellItem?.endtime,
        rcellItem?.shift,
        rcellItem?.team,
        rcellItem?.location,
        rcellItem?.status,
      ];
    }
  }

  const downloadForExcel = async (rcellItem, emailSend) => {
    const rcellItems = rcellItem?.records ? rcellItem?.records : rcellItem;
    let wb = new Excel.Workbook();
    let ws = wb.addWorksheet('Upcoming Appointment Report');

    const clientCSV = getDatatoDownload(rcellItems);
    let fileName;
    if (Array.isArray(rcellItems)) {
      fileName = `UpcomingAppointmentReport_${rcellItems[0]?.clientName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    } else {
      fileName = `UpcomingAppointmentReport_${rcellItems?.clientName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    }
    return await downloadExcel(clientCSV, csvHeaders, wb, ws, fileName, emailSend)
  }

  const downloadForPDF = async (rcellItem, emailSend) => {
    const rcellItems = rcellItem?.records ? rcellItem?.records : rcellItem;
    const clientCSV = getDatatoDownload(rcellItems);
    let fileName;
    if (Array.isArray(rcellItems)) {
      fileName = `UpcomingAppointmentReport_${rcellItems[0]?.clientName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    } else {
      fileName = `UpcomingAppointmentReport_${rcellItems?.clientName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    }
    const logo = settingsData?.[0]?.companyLogo;
    return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend);
  }

  const setDownloadCSVData = (event, done, rcellItem) => {
    const rcellItems = rcellItem?.records ? rcellItem?.records : rcellItem;
    const clientCSV = getDatatoDownload(rcellItems);

    const reportName = "Upcoming Appointment Report";
    const clientName = Array.isArray(rcellItems) ? `${rcellItems[0]?.clientName}` : `${rcellItems?.clientName}`;
    const reportPeriod = `${moment(startDate).format("YYYY-MM-DD")} to ${moment(endDate).format("YYYY-MM-DD")}`;
    // Create the report details rows
    const reportDetails = [
      [`Client Name: ${clientName}`],
      [`Report Name: ${reportName}`],
      [`Report Period: ${reportPeriod}`],
      [],
      [...csvHeaders],
      ...clientCSV
    ];

    // Set the CSV data
    setClientListCSV(reportDetails);
    done();
  };

  const setDownloadFullCSVData = (event, done) => {
    const clientCSV = clientsList?.map((item) => getDatatoFullDownload(item));
    let clientNamefordwonLoad = "All";

    if (clientName !== "All") {
      clientNamefordwonLoad = clientNameList?.filter(
        (item) => item.value === clientName
      )[0]?.label;
    }

    const reportName = "Upcoming Appointment Report";
    const reportPeriod = `${moment(startDate).format("YYYY-MM-DD")} to ${moment(
      endDate
    ).format("YYYY-MM-DD")}`;

    const reportDetails = [
      [`Employee Name: ${clientNamefordwonLoad}`],
      [`Report Name: ${reportName}`],
      [`Report Period: ${reportPeriod}`],
      [],
      [...csvHeaders],
      ...clientCSV,
    ];

    setClientListCSV(reportDetails);
    done();
  };


  const downloadForFullPDF = async (emailSend) => {
    const clientCSV = clientsList.map((item) => getDatatoFullDownload(item));
    let clientNamefordwonLoad = 'All'

    if (clientName !== 'All') {
      clientNamefordwonLoad = clientNameList.filter((item) => item.value === clientName)[0].label
    }
    let fileName = `UpcomingAppointmentReport_${clientNamefordwonLoad}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`
    const logo = settingsData?.[0]?.companyLogo;
    return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend);
  }

  const downloadForFullExcel = async (emailSend) => {
    let wb = new Excel.Workbook();
    let ws = wb.addWorksheet('Upcoming Appointment Report');
    let clientNamefordwonLoad = 'All'

    const clientCSV = clientsList.map((item) => getDatatoFullDownload(item));

    if (clientName !== 'All') {
      clientNamefordwonLoad = clientNameList.filter((item) => item.value === clientName)[0].label
    }
    let fileName = `UpcomingAppointmentReport_${clientNamefordwonLoad}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`
    return await downloadExcel(clientCSV, csvHeaders, wb, ws, fileName, emailSend)
  }

  const handleEmailIconClick = async (rcellItem) => {
    const emailSend = true;
    const excelBlob = await downloadForExcel(rcellItem, emailSend);
    let name;
    if (Array.isArray(rcellItem)) {
      name = rcellItem[0]?.clientName;
    } else {
      name = rcellItem?.clientName;
    }
    localStorage.setItem("FileName", "UpcomingAppointmentReport");

    localStorage.setItem("ReportsName", "Client Report");

    localStorage.setItem("Name", name);

    localStorage.setItem("Date", startDate);

    localStorage.setItem("EndDate", endDate);

    const pdfBlob = await downloadForPDF(rcellItem, emailSend);
    localStorage.setItem("pdfData", pdfBlob);
    localStorage.removeItem("fullReport")
    localStorage.removeItem("fullExcelReport")

    // Convert the Excel blob to a base64-encoded string
    const reader = new FileReader();
    reader.readAsDataURL(excelBlob);
    reader.onloadend = function () {
      const base64Data = reader.result;
      localStorage.setItem("emailData", base64Data);
      setOpenEmailDialog(true);
    };
  };

  const handelEmailFullReport = async () => {
    const emailSend = true;

    localStorage.setItem("FileName", "UpcomingAppointmentReport");

    localStorage.setItem("ReportsName", "Client Report");

    let clientNamefordwonLoad = 'All'

    if (clientName !== 'All') {
      clientNamefordwonLoad = clientNameList?.filter((item) => item.value === clientName)[0]?.label
    }
    localStorage.setItem("Name", clientNamefordwonLoad);

    localStorage.setItem("Date", startDate);

    localStorage.setItem("EndDate", endDate);

    const fullReport = await downloadForFullPDF(emailSend);
    localStorage.setItem("fullReport", fullReport);
    localStorage.removeItem("pdfData")
    localStorage.removeItem("emailData")

    const fullExcelReport = await downloadForFullExcel(emailSend);
    const reader = new FileReader();
    reader.readAsDataURL(fullExcelReport);
    reader.onloadend = function () {
      const base64Data = reader.result;
      localStorage.setItem("fullExcelReport", base64Data);
      setOpenEmailDialog(true);
    }
  }

  const handleGenerateReport = async() => {
      setLoader(true);
      let paramStartDate = "";
      let paramEndDate = "";

      paramStartDate = startDate;
      paramEndDate = endDate;
      getReportListData(paramStartDate, paramEndDate);
  }

  const mapWithClientIds = async (employeeIds, timeSheet) => {
    getEmployeesListBasedOnId(employeeIds, (result) => {
      const finaleData = timeSheet?.map((resItem) => {
        const userTimeSheet = clients?.filter(
          (itm) => itm.id === resItem?.clientId
        );
        const empDetails = result?.filter(
          (itm) => itm.id === resItem?.userId
        );

        const startTime = resItem?.apoointmentDetails?.time;
        const endTime = resItem?.apoointmentDetails?.endTime;
        // const taskTitles = Object.values(resItem?.tasks)?.map((task) => task?.title);
        const taskTitles = !resItem?.tasks || Object.keys(resItem?.tasks)?.length === 0  ? ['"No Shift"'] : Object.values(resItem.tasks).map((task) => task.title);
        const formValues = resItem?.apoointmentDetails?.forms?.[0]?.values || [];
        const addressParts = [
          formValues?.find(f => f?.name === "Address")?.value,
          formValues?.find(f => f?.name === "City")?.value,
          formValues?.find(f => f?.name === "State")?.value,
          formValues?.find(f => f?.name === "ZipCode")?.value
        ]?.filter(Boolean);

        const fullAddress = addressParts?.filter(Boolean)?.join(", ");
        const status = resItem?.apoointmentDetails?.historyDate ? "ReScheduled" : "Scheduled"

        resItem["clientName"] = `${userTimeSheet?.[0]?.firstName} ${userTimeSheet?.[0]?.lastName}`;
        resItem["clientNameId"] = resItem?.clientId;
        resItem["appointmentDate"] = resItem?.apoointmentDetails?.date;
        resItem["time"] = startTime;
        resItem["endtime"] = endTime;
        resItem["shift"] = taskTitles?.[0];
        resItem["team"] = `${empDetails?.[0]?.firstName} ${empDetails?.[0]?.lastName}`
        resItem["location"] = fullAddress;
        resItem["status"] = status;

        return resItem;
      });

      let sortedData = sortingFunction(finaleData);
      setClientsListMaster(sortedData);

      setClientList(() =>
        sortedData?.filter((itme) => {
          let returnFlg = true;
          if (clientName !== "All") {
            returnFlg = itme.clientNameId === clientName;
          }
          return returnFlg;
        })
      );
      setLoader(false)
    });
  };

  const sortingFunction = (data) => {
    const result = data.sort((a, b) => {
      if (a.clientName < b.clientName) return -1;
      if (a.clientName > b.clientName) return 1;
      // If clientName is the same, sort by appointmentDate
      if (a.appointmentDateTime < b.appointmentDateTime) return -1;
      if (a.appointmentDateTime > b.appointmentDateTime) return 1;
      return 0;
    });

    return result;
  };

  const getReportListData = async (startDt, endDt) => {
    const param = {
      startDate: `${dayjs(startDt).format("YYYY-MM-DD")}T00:00:00`,
      endDate: `${dayjs(endDt).format("YYYY-MM-DD")}T23:59:59`
    };

    getUpcomingClientTimesheetListReport(
      param,
      clientName,
      companyId,
      (result) => {
        const data = result;
        const employeeIds = [];
        for (let i = 0; i < data?.length; i++) {
          if (employeeIds?.indexOf(data?.[i].userId) === -1) {
            employeeIds?.push(data?.[i].userId);
          }
        }

        mapWithClientIds(employeeIds, data);
      },
      (err) => {
        console.log("err>>", err);
      }
    );
  };


  const getStatusBadgeColor = (status) => {
    switch (status) {
      case 'confirmed':
        return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200';
      case 'Scheduled':
        return 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200';
      case 'ReScheduled':
        return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200';
      default:
        return 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200';
    }
  };

  const renderRowCell = (rcellItem, hcellItem, index, rowindex,) => {
    switch (hcellItem.id) {
      case "clientName":
        if (
          rowindex !== 0 &&
          clientsList[rowindex - 1].clientName !== rcellItem.clientName
        ) {
          return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
        } else if (rowindex === 0) {
          return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
        } else {
          return "";
        }
      case "time":
        return (
          <div className={`text-blue-600`}>
            {rcellItem?.time}
          </div>
        )
      case "endtime":
        return (
          <div className={`text-blue-600`}>
            {rcellItem?.endtime}
          </div>
        )
      case "status":
        return (
          <div className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusBadgeColor(rcellItem?.status)}`}>
            {rcellItem?.status}
          </div>
        )
      case "location":
        return (
          <Tooltip>
            <TooltipTrigger asChild>
              <Button variant="ghost" size="sm" className="h-6 w-6 p-0">
                <Info className="h-3 w-3" />
              </Button>
            </TooltipTrigger>
            <TooltipContent className="max-w-xs">
              <p className="text-sm">{rcellItem?.location}</p>
            </TooltipContent>
          </Tooltip>
        );
      case "Action":
        if (isMobile || isLandscape) {
          if (rowindex === 0) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"UpcomingAppointmentReport"}
              />
            );
          } else {
            return null;
          }
        } else {
          if (
            rowindex !== 0 &&
            clientsList[rowindex - 1].clientName !== rcellItem.clientName
          ) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"UpcomingAppointmentReport"}
              />
            );
          } else if (rowindex === 0) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"UpcomingAppointmentReport"}
              />
            );
          } else {
            return "";
          }
        }
      default:
        return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
    }
  };

  const MobileViewData = useMemo(() => {
    if (!clientsList?.length) return [];

    return clientsList?.reduce((acc, item) => {
      const clientName = item?.clientName;

      const record = {
        id: item?.clientNameId,
        date: item?.appointmentDate,
        clientNameId: item?.clientNameId,
        clientName: item?.clientName,
        time: item?.time,
        endtime: item?.endtime,
        shift: item?.shift,
        team: item?.team,
        location: item?.location,
        status: item?.status,
        priority: item?.priority,
      };

      const existingGroup = acc?.find((g) => g?.clientName === clientName);

      if (existingGroup) {
        existingGroup?.records?.push(record);
      } else {
        acc?.push({
          clientName,
          records: [record],
        });
      }

      return acc;
    }, []);
  }, [clientsList]);

    const filteredClient = clients?.find((item) => item?.id === clientName);

    const handleEmailDialogClose = async() => {
      setOpenEmailDialog(false);
      await handleGenerateReport();
    }


  return (
    <>
      <Container>
          <PageTitle
            pageTitle="Upcoming Appointments Reports"
            showBreadcrumb={[
              { label: "Home", to: "/" },
              { label: "Reports" },
              { label: "New Reports" },
              { label: "Client Reports", to: "/reports/newreport/clientreport" },
            ]}
            BreadCrumbCurrentPageTitle={"Upcoming Appointments Reports"}
            showLastSeen={true}
          ></PageTitle>

          <div className={`sectionBox2 dark:bg-[#1A1F2C]`}>
            <div className="mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 max-w-7xl dark:bg-[#1A1F2C]">
              <div className="space-y-6">
                <Card className="shadow-sm dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] p-24">
                  <CardHeader className="pb-12">
                    <div className="flex items-center space-x-2">
                      <Filter className="w-4 h-4 sm:w-5 sm:h-5 text-primary" />
                      <CardTitle className="text-lg sm:text-xl">
                        Report Parameters
                      </CardTitle>
                    </div>
                    <CardDescription className="text-left text-sm sm:text-base">
                      Configure the parameters for your upcoming appointment report
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                      <div className="flex flex-col space-y-1">
                        <Label
                          htmlFor="client"
                          className="text-sm font-medium text-gray-700 dark:text-white"
                        >
                          Client Name *
                        </Label>
                        <SingleSelectNew
                          value={clientName}
                          name={"clientName"}
                          label={"Client Name"}
                          onChange={(e) => handleclientNameChange(e)}
                          options={clientNameList}
                          contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                          itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                          className="w-full min-h-[40px] px-3 py-2"
                        />
                      </div>

                      <div className="flex flex-col space-y-1">
                        <Label
                          htmlFor="startDate"
                          className="text-sm font-medium text-gray-700 dark:text-white"
                        >
                          Start Date *
                        </Label>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <DatePicker
                            value={startDate}
                            onChange={(newValue) => {
                              setStartDate(newValue);
                              // if (newValue) {
                              //   setEndDate(moment());
                              // } else {
                              //   setEndDate(null);
                              // }
                            }}
                            minDate={moment()}
                            views={["year", "month", "day"]}
                            inputFormat="YYYY-MM-DD"
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                size: "small",
                                fullWidth: true,
                                className: "customDateInput",
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div>

                      <div className="flex flex-col space-y-1">
                        <Label
                          htmlFor="endDate"
                          className="text-sm font-medium text-gray-700 dark:text-white"
                        >
                          End Date *
                        </Label>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <DatePicker
                            value={endDate}
                            onChange={(newValue) => {
                              setEndDate(newValue);
                              // if (!newValue) {
                              //   setStartDate(null);
                              // }
                            }}
                            minDate={moment()}
                            views={["year", "month", "day"]}
                            inputFormat="YYYY-MM-DD"
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                size: "small",
                                fullWidth: true,
                                className: "customDateInput",
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                    <div className="flex justify-start sm:justify-end pt-8">
                      <Button
                        type="submit"
                        className="w-full sm:w-auto h-10 text-sm px-6"
                        onClick={() => handleGenerateReport()}
                      >
                        {loader ? (
                          <CircularProgress
                            size={28}
                            style={{ color: "white" }}
                          />
                        ) : (
                          <span className="d-flex flex-center">
                            <FileText className="w-4 h-4 mr-8" /> Generate
                            Report
                          </span>
                        )}
                      </Button>
                    </div>
                  </CardContent>
                </Card>
    
                {loader ? (
                  <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] flex items-center justify-center min-h-[200px]">
                    <div className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
                      Fetching report data...
                    </div>
                  </Card>
                ) : clientsList?.length === 0 ? (
                  <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] flex items-center justify-center min-h-[200px]">
                    <div className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
                      No Records Found
                    </div>
                  </Card>
                ) : (
                  clientsList?.length > 0 && (
                    <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
                      <CardHeader className="pb-16">
                        <div className="flex flex-col space-y-4 lg:flex-row lg:items-start lg:justify-between lg:space-y-0">
                          <div className="space-y-3 flex-1 min-w-0">
                            <CardTitle className="text-lg sm:text-xl d-flex flex-center">
                              <span>
                                  <Calendar className="h-5 w-5 mr-3 text-blue-600 dark:text-blue-400"/>
                              </span>
                             Upcoming Appointments Report Results
                            </CardTitle>
                            <CardDescription className="space-y-2">
                              <div className="font-medium text-sm sm:text-base">
                                {clientName === "All"
                                  ? "All Client Report"
                                  : `Client Report for ${filteredClient?.firstName} ${filteredClient?.lastName}`}
                              </div>
                              <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">
                              </div>
                            </CardDescription>
                          </div>
                          <div className="flex flex-wrap gap-2">
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => handelEmailFullReport()}
                              className="h-8"
                            >
                              <Mail className="mr-4 h-3 w-3" />
                              Email Report
                            </Button>
                            <Popover>
                              <PopoverTrigger asChild>
                                <Button
                                  variant="outline"
                                  size="sm"
                                  className="h-8"
                                >
                                  <Download className="mr-4 h-3 w-3" />
                                  Download
                                </Button>
                              </PopoverTrigger>
                              <PopoverContent className="w-40">
                                <div className="space-y-2">
                                  <Button
                                    variant="ghost"
                                    className="w-full justify-start h-8"
                                    onClick={() => downloadForFullPDF()}
                                  >
                                    <FileText className="mr-8 h-3 w-3" />
                                    PDF
                                  </Button>
                                  <Button
                                    variant="ghost"
                                    className="w-full justify-start h-8"
                                    onClick={() => downloadForFullExcel()}
                                  >
                                    <FileSpreadsheet className="mr-8 h-3 w-3" />
                                    Excel
                                  </Button>
                                  <CSVLink
                                    data={clientsListCSV}
                                    filename={`UpcomingAppointmentReport_${
                                      clientName === "All"
                                        ? "All"
                                        : `${filteredClient?.firstName} ${filteredClient?.lastName}`
                                    }_${moment(startDate).format(
                                      "YYYY-MM-DD"
                                    )}_${moment(endDate).format(
                                      "YYYY-MM-DD"
                                    )}.csv`}
                                    asyncOnClick={true}
                                    onClick={(event, done) => {
                                      setDownloadFullCSVData(event, done);
                                    }}
                                    className="w-full flex justify-start items-center h-8 pv-8 ph-16 text-sm hover:bg-accent hover:text-accent-foreground rounded-md transition-colors"
                                  >
                                    <FileSpreadsheet className="mr-16 h-4 w-4" />
                                    <span className="font-medium">CSV</span>
                                  </CSVLink>
                                </div>
                              </PopoverContent>
                            </Popover>
                          </div>
                        </div>
                      </CardHeader>
                      <CardContent className="p-0 sm:p-6 sm:pt-0">
                        {!isMobile && (
                          <TooltipProvider>
                          <ThemeTable
                            rows={clientsList}
                            headCells={getColumns()}
                            hidePagination={true}
                            renderRowCell={renderRowCell}
                          />
                          </TooltipProvider>
                        )}
                        {isMobile && (
                          <MobileUpcomingAppointmentReport
                            MobileViewData={MobileViewData}
                            handleEmailIconClick={handleEmailIconClick}
                            downloadForPDF={downloadForPDF}
                            downloadForExcel={downloadForExcel}
                            clientsListCSV={clientsListCSV}
                            setDownloadCSVData={setDownloadCSVData}
                            startDate={startDate}
                            endDate={endDate}
                            reportName={"UpcomingAppointmentReport"}
                          />
                        )}
                      </CardContent>
                    </Card>
                  )
                )}
              </div>
            </div>
          </div>
          <EmailReports
            open={openEmailDialog}
            onClose={() => handleEmailDialogClose()}
          />
        </Container>
    </>
  );
}

export default UpcomingAppointments;